import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { NotificationActionTrigger, NotificationStatus } from '@makyoapp/makyo-sdk/models/Notifications'
import { Button, JustifyVariant, Modal } from '@makyoapp/makyo-ui'

import { useReqNotif } from '../hooks/useReqNotif'
import {
  InvitationAccept,
  InvitationDecline,
  InvitationFooterEnd,
  InvitationNotMatch,
  InvitationProcessed,
} from './InvitationModal'

interface Props {
  show: boolean
}

export default function OwnershipInvitationModal({ show }: Props) {
  const { t } = useTranslation()
  const [step, setStep] = useState(1)
  const { action, data, showNotMatch, onHideWithClean, onHide, isLoading, setIsLoading, isOnBoarding, invitation } =
    useReqNotif(NotificationActionTrigger.ChangingOrgOwnership)

  const orgName = data?.OrgName || ''
  const inviteeOrgId = data?.OrgID || ''
  // @ts-ignore
  const name = data?.Name || ''
  const invProcessed =
    invitation?.status === NotificationStatus.Accepted || invitation?.status === NotificationStatus.Declined

  return (
    <>
      <InvitationNotMatch show={showNotMatch} onIgnore={onHideWithClean} />
      <Modal show={show}>
        <Modal.Body className='modal-sm'>
          {invProcessed ? (
            <InvitationProcessed status={invitation.status} />
          ) : (
            <div className='text-base'>
              {step === 1 && (
                <Trans i18nKey='ownershipInvitationDetail' values={{ orgName, name }}>
                  You&apos;re invited to be owner of <strong>{orgName}</strong> by <strong>{name}</strong>
                </Trans>
              )}
              {step === 2 && (
                <>
                  <div className='mb-2'>
                    <Trans i18nKey='declinedOwnership' values={{ orgName }}>
                      You&apos;ve declined the invitation to own <strong>{orgName}</strong>!
                    </Trans>
                  </div>
                  <div>{t('What would you like to do next?')}</div>
                </>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer justify={JustifyVariant.End} className='gap-4'>
          {invProcessed && <Button onClick={onHideWithClean}>{t('Ok')}</Button>}
          {!invProcessed && step === 1 && (
            <>
              <InvitationDecline isLoading={isLoading} setStep={setStep} action={action} data={data} />
              <InvitationAccept
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                onHide={onHide}
                inviteeOrgId={inviteeOrgId}
                action={action}
                data={data}
              />
            </>
          )}
          {
            /// declined invitation and is an existing user
            !invProcessed && step === 2 && !isOnBoarding && (
              <InvitationFooterEnd isLoading={isLoading} onHide={onHideWithClean} />
            )
          }
        </Modal.Footer>
      </Modal>
    </>
  )
}
